import type { FastifyInstance } from 'fastify'
import type { Firestore } from 'firebase-admin/firestore'
import type { RedisClient } from '../../core/redis/client.js'
import { PlannerRepository } from './planner.repository'
import { PlannerService } from './planner.service'
import { PlannerController } from './planner.controller'
import { RouteOptimizer } from './route-optimizer'
import { plannerRoutes } from './planner.routes'
import { PlannerAIService } from './planner-ai.service'

export default async function plannerModule(
  app: FastifyInstance,
  firestore: Firestore,
  redis: RedisClient
) {
  const enableRateLimit = process.env.ENABLE_PLANNER_RATE_LIMIT !== 'false'
  if (enableRateLimit) {
    await app.register(
      await import('@fastify/rate-limit').then(mod => mod.default || mod),
      {
  // Default planner rate limit increased 10x (can be overridden via env)
  max: Number(process.env.PLANNER_RATE_LIMIT_MAX ?? 200),
        timeWindow: process.env.PLANNER_RATE_LIMIT_WINDOW ?? '1 minute',
        ban: Number(process.env.PLANNER_RATE_LIMIT_BAN ?? 0),
        keyGenerator: (request) => request.user?.uid || request.ip,
        errorResponseBuilder: () => ({
          error: 'Too Many Requests',
          statusCode: 429,
          timestamp: new Date().toISOString()
        })
      }
    )
  }

  // Initialize dependencies
  const repository = new PlannerRepository(firestore)
  const routeOptimizer = new RouteOptimizer()
  const aiService = new PlannerAIService()
  const service = new PlannerService(repository, redis, routeOptimizer, aiService)
  const controller = new PlannerController(service)

  // Register routes
  await plannerRoutes(app, controller)
}
